var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmRegistration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 275,
    viewBox: "0 0 316 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.57 165.687L144.987 176.622L151.689 199.162L188.272 188.228L181.57 165.687Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.944 166.481L145.601 177.045L151.856 198.083L187.2 187.519L180.944 166.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M148.622 181.485L153.12 180.141L152.128 176.804L147.63 178.149L148.622 181.485Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M154.241 186.872L171.506 181.712L171.184 180.63L153.919 185.791L154.241 186.872Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M159.616 187.818L172.205 184.055L171.99 183.334L159.401 187.097L159.616 187.818Z",
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.581 112.251L234.096 135.338L271.566 142.654L276.051 119.567L238.581 112.251Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.339 113.267L234.178 134.781L270.321 141.807L274.481 120.293L238.339 113.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M239.511 118.281L244.118 119.18L244.781 115.763L240.175 114.863L239.511 118.281Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M241.997 125.666L259.681 129.119L259.896 128.01L242.213 124.558L241.997 125.666Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M246.322 129.005L259.216 131.523L259.36 130.784L246.466 128.266L246.322 129.005Z",
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.883 157.83L240.361 167.19L255.552 202.302L277.074 192.942L261.883 157.83Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.534 158.495L241.446 167.231L256.123 201.154L276.211 192.417L261.534 158.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M257.443 162.019L259.311 166.336L262.497 164.95L260.629 160.633L257.443 162.019Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M252.778 168.256L259.947 184.826L260.98 184.377L253.811 167.806L252.778 168.256Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M252.478 173.718L257.706 185.801L258.395 185.502L253.167 173.419L252.478 173.718Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.353 54.8101L120.77 65.7443L127.472 88.2847L164.055 77.3505L157.353 54.8101Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.727 55.6072L121.384 66.1709L127.64 87.2093L162.983 76.6456L156.727 55.6072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M124.385 70.6184L128.883 69.274L127.891 65.9375L123.393 67.2818L124.385 70.6184Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.008 76.0045L147.272 70.8442L146.951 69.7624L129.686 74.9226L130.008 76.0045Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M135.379 76.9512L147.968 73.1885L147.753 72.4672L135.164 76.2299L135.379 76.9512Z",
    fill: "#F55F44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.355 1.37871L209.871 24.4657L247.341 31.7817L251.825 8.69469L214.355 1.37871Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.704 2.0448L210.518 23.5934L246.719 30.6615L250.904 9.11287L214.704 2.0448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M215.284 7.41119L219.891 8.31067L220.555 4.89316L215.948 3.99368L215.284 7.41119Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M217.771 14.7963L235.454 18.249L235.67 17.1409L217.986 13.6883L217.771 14.7963Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M222.096 18.1328L234.99 20.6504L235.134 19.9117L222.24 17.3941L222.096 18.1328Z",
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.653 46.961L216.13 56.321L231.322 91.4332L252.844 82.0731L237.653 46.961Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.308 47.6246L217.22 56.361L231.896 90.2832L251.984 81.5469L237.308 47.6246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M233.218 51.1503L235.086 55.4673L238.272 54.0817L236.404 49.7648L233.218 51.1503Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M228.549 57.3872L235.719 73.9579L236.752 73.5086L229.582 56.938L228.549 57.3872Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M228.251 62.8534L233.479 74.9362L234.167 74.6367L228.94 62.5539L228.251 62.8534Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.5748 138.252L17.9918 149.186L24.6939 171.726L61.277 160.792L54.5748 138.252Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9526 139.048L18.6092 149.612L24.8648 170.65L60.2081 160.086L53.9526 139.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.6271 154.073L26.1249 152.729L25.1328 149.392L20.635 150.737L21.6271 154.073Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.2498 159.459L44.5146 154.299L44.193 153.217L26.9281 158.377L27.2498 159.459Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.6247 160.405L45.2136 156.642L44.9992 155.921L32.4102 159.684L32.6247 160.405Z",
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.588 84.8267L107.104 107.914L144.574 115.23L149.058 92.1427L111.588 84.8267Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.535 85.676L107.375 107.19L143.517 114.216L147.678 92.7015L111.535 85.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.514 90.8553L117.121 91.7548L117.785 88.3372L113.178 87.4378L112.514 90.8553Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M115.004 98.241L132.688 101.694L132.903 100.586L115.219 97.1329L115.004 98.241Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.329 101.58L132.223 104.098L132.366 103.359L119.472 100.842L119.329 101.58Z",
    fill: "#F55F44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.887 130.407L113.365 139.767L128.557 174.879L150.079 165.519L134.887 130.407Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.542 131.071L114.454 139.807L129.131 173.729L149.219 164.993L134.542 131.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.45 134.597L132.317 138.913L135.503 137.528L133.635 133.211L130.45 134.597Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.784 140.83L132.954 157.4L133.987 156.951L126.817 140.38L125.784 140.83Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.486 146.294L130.714 158.377L131.402 158.078L126.175 145.995L125.486 146.294Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.8794 72.0415L22.2963 82.9757L28.9985 105.516L65.5816 94.5819L58.8794 72.0415Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9103 72.4831L23.5051 83.2062L29.8551 104.281L65.2603 93.5583L58.9103 72.4831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.9211 87.8642L30.4189 86.5199L29.4268 83.1833L24.929 84.5276L25.9211 87.8642Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M31.5403 93.2514L48.8051 88.0912L48.4834 87.0093L31.2186 92.1696L31.5403 93.2514Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.9151 94.197L49.5041 90.4343L49.2896 89.7131L36.7007 93.4758L36.9151 94.197Z",
    fill: "#037DBA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.582 18.89L111.125 41.9403L148.535 49.2122L152.993 26.1619L115.582 18.89Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.235 19.2837L112.049 40.8323L148.25 47.9003L152.435 26.3518L116.235 19.2837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M116.816 24.6498L121.422 25.5493L122.086 22.1318L117.479 21.2323L116.816 24.6498Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M119.303 32.0313L136.987 35.484L137.202 34.3759L119.518 30.9232L119.303 32.0313Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M123.624 35.3706L136.518 37.8882L136.662 37.1495L123.767 34.6319L123.624 35.3706Z",
    fill: "#F55F44"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.187 64.2004L117.665 73.5604L132.856 108.673L154.378 99.3125L139.187 64.2004Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.839 64.8656L118.75 73.6019L133.427 107.524L153.515 98.7879L138.839 64.8656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M134.752 68.3892L136.619 72.7062L139.805 71.3206L137.937 67.0037L134.752 68.3892Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M130.083 74.6261L137.252 91.1968L138.285 90.7475L131.116 74.1768L130.083 74.6261Z",
    fill: "#47E6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M129.787 80.0839L135.014 92.1666L135.703 91.8671L130.475 79.7844L129.787 80.0839Z",
    fill: "#47E6B1"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M23.2849 24.3792C24.3857 24.3792 25.2781 23.4844 25.2781 22.3807C25.2781 21.277 24.3857 20.3823 23.2849 20.3823C22.184 20.3823 21.2916 21.277 21.2916 22.3807C21.2916 23.4844 22.184 24.3792 23.2849 24.3792Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M231.376 199.414C232.477 199.414 233.37 198.52 233.37 197.416C233.37 196.312 232.477 195.417 231.376 195.417C230.276 195.417 229.383 196.312 229.383 197.416C229.383 198.52 230.276 199.414 231.376 199.414Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M55.3115 189.477C56.4124 189.477 57.3048 188.582 57.3048 187.479C57.3048 186.375 56.4124 185.48 55.3115 185.48C54.2107 185.48 53.3183 186.375 53.3183 187.479C53.3183 188.582 54.2107 189.477 55.3115 189.477Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M249.906 161.66C251.007 161.66 251.899 160.765 251.899 159.662C251.899 158.558 251.007 157.663 249.906 157.663C248.805 157.663 247.913 158.558 247.913 159.662C247.913 160.765 248.805 161.66 249.906 161.66Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M268.661 69.9885C269.762 69.9885 270.655 69.0938 270.655 67.9901C270.655 66.8864 269.762 65.9917 268.661 65.9917C267.561 65.9917 266.668 66.8864 266.668 67.9901C266.668 69.0938 267.561 69.9885 268.661 69.9885Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M121.504 1.77921H119.733V0H119.008V1.77921H117.237V2.50259H119.008V4.27815H119.733V2.50259H121.504V1.77921Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M53.3074 29.0081H51.5365V27.2325H50.8113V29.0081H49.0403V29.7351H50.8113V31.5107H51.5365V29.7351H53.3074V29.0081Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M25.566 130.475H23.7951V128.699H23.0699V130.475H21.299V131.202H23.0699V132.977H23.7951V131.202H25.566V130.475Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M21.5832 58.1149H19.8085V56.3357H19.087V58.1149H17.3124V58.8383H19.087V60.6175H19.8085V58.8383H21.5832V58.1149Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.26707 107.838H2.49611V106.059H1.77461V107.838H0V108.561H1.77461V110.337H2.49611V108.561H4.26707V107.838Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M316 82.1983H314.229V80.4227H313.504V82.1983H311.733V82.9253H313.504V84.7009H314.229V82.9253H316V82.1983Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M254.26 105.313H252.49V103.534H251.764V105.313H249.993V106.037H251.764V107.816H252.49V106.037H254.26V105.313Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M201.54 42.9715H199.765V41.1959H199.044V42.9715H197.269V43.6985H199.044V45.4741H199.765V43.6985H201.54V42.9715Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8079 144.58C98.5325 148.731 100.446 153.637 104.181 155.822C105.744 156.735 107.548 157.199 109.067 158.189C112.365 160.341 113.666 164.47 114.737 168.265C115.965 172.631 117.2 177.246 116.075 181.637C115.346 184.435 113.724 186.912 112.795 189.653C112.019 191.947 111.749 194.382 112.004 196.791C112.139 198.07 112.46 199.4 113.331 200.342C114.591 201.705 116.61 201.91 118.432 202.239C122.291 202.973 125.921 204.614 129.025 207.028C132.129 209.441 134.618 212.557 136.288 216.122",
    stroke: "url(#paint12_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.198 144.58C98.9224 148.731 100.835 153.637 104.571 155.822C106.134 156.735 107.938 157.199 109.457 158.189C112.755 160.341 114.056 164.47 115.127 168.265C116.355 172.631 117.59 177.246 116.464 181.637C115.736 184.435 114.114 186.912 113.185 189.653C112.409 191.947 112.139 194.382 112.394 196.791C112.529 198.07 112.85 199.4 113.721 200.342C114.981 201.705 117 201.91 118.822 202.239C122.681 202.973 126.311 204.614 129.415 207.028C132.518 209.441 135.007 212.557 136.677 216.122",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.469 113.57C145.325 117.954 142.06 122.704 141.79 128.1C141.378 136.404 147.985 143.196 150.962 150.963C152.242 154.383 152.821 158.028 152.665 161.678C152.508 165.328 151.619 168.91 150.051 172.207C148.593 175.2 146.549 178.17 146.8 181.483C146.953 183.507 147.963 185.345 148.775 187.205C150.77 191.865 151.64 196.93 151.316 201.991C150.992 207.051 149.482 211.964 146.91 216.33",
    stroke: "url(#paint13_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.859 113.57C145.714 117.954 142.449 122.704 142.18 128.1C141.768 136.404 148.374 143.196 151.352 150.963C152.633 154.383 153.213 158.028 153.057 161.678C152.901 165.328 152.012 168.909 150.444 172.207C148.987 175.2 146.942 178.17 147.194 181.483C147.347 183.507 148.356 185.345 149.169 187.205C151.163 191.865 152.034 196.93 151.709 201.991C151.385 207.051 149.876 211.964 147.303 216.33",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.619 153.122L194.139 165.544C194.339 167.195 194.503 168.996 193.629 170.403C192.791 171.736 191.22 172.372 189.985 173.358C185.976 176.592 186.341 182.802 187.711 187.782C189.081 192.762 191.093 198.11 189.169 202.9C188.374 204.876 186.982 206.553 185.922 208.38C184.145 211.552 183.44 215.215 183.914 218.821",
    stroke: "url(#paint14_linear)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.984 153.122L194.503 165.544C194.704 167.195 194.868 168.996 193.993 170.403C193.155 171.736 191.585 172.372 190.349 173.358C186.341 176.592 186.705 182.802 188.075 187.782C189.446 192.762 191.457 198.11 189.533 202.9C188.739 204.876 187.347 206.553 186.286 208.38C184.509 211.552 183.805 215.215 184.278 218.821",
    stroke: "#535461",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M232.054 102.022C232.05 96.2078 230.673 90.4775 228.038 85.2987C225.403 80.1199 221.583 75.6394 216.891 72.2233C212.199 68.8071 206.767 66.5521 201.04 65.6424C195.312 64.7328 189.451 65.1942 183.936 66.9891C184.24 64.918 184.397 62.8278 184.406 60.7344C184.465 51.1539 180.799 41.9272 174.186 35.0114C167.573 28.0955 158.532 24.0347 148.983 23.6901C139.433 23.3456 130.125 26.7444 123.033 33.1657C115.941 39.587 111.623 48.5257 110.995 58.0857C105.479 56.2874 99.616 55.8232 93.8865 56.731C88.157 57.6388 82.723 59.8928 78.0285 63.309C73.3341 66.7251 69.5124 71.2064 66.8758 76.3866C64.2392 81.5668 62.8625 87.299 62.8582 93.1147C62.8582 111.601 76.4356 137.895 94.1416 142.553L96.8927 144.131L95.3987 149.268H104.254L102.33 144.124L105.07 142.553C118.749 138.954 129.962 122.441 134.356 106.588C136.76 108.196 139.407 109.404 142.194 110.165L144.946 111.743L143.452 116.88H152.306L150.382 111.736L153.123 110.165C155.156 109.617 157.114 108.819 158.953 107.79C161.318 125.564 173.893 147.269 189.832 151.46L192.583 153.038L191.089 158.175H199.944L198.02 153.031L200.76 151.46C218.492 146.802 232.054 120.508 232.054 102.022Z",
    fill: "url(#paint15_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.649 147.383H97.0822L98.5799 142.228H103.722L105.649 147.383Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.71 93.0489C136.71 112.737 120.79 141.585 101.152 141.585C81.5152 141.585 65.5948 112.723 65.5948 93.0489C65.5948 83.5939 69.341 74.5261 76.0094 67.8405C82.6778 61.1548 91.722 57.3988 101.152 57.3988C110.583 57.3988 119.627 61.1548 126.296 67.8405C132.964 74.5261 136.71 83.5939 136.71 93.0489Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.722 142.443H98.5799L95.5809 140.726H106.72L103.722 142.443Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.3003 65.3451C88.3003 65.3451 73.3054 73.5068 71.1737 89.823L88.3003 65.3451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.15 116.043H143.583L145.08 110.888H150.222L152.15 116.043Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.211 61.7062C183.211 81.3945 167.29 110.242 147.653 110.242C128.016 110.242 112.088 81.3981 112.088 61.7062C112.088 52.2512 115.834 43.1835 122.503 36.4978C129.171 29.8121 138.215 26.0562 147.646 26.0562C157.076 26.0562 166.12 29.8121 172.789 36.4978C179.457 43.1835 183.203 52.2512 183.203 61.7062H183.211Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.222 111.104H145.08L142.081 109.383H153.221L150.222 111.104Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M134.801 34.0023C134.801 34.0023 119.806 42.1641 117.674 58.4802L134.801 34.0023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.26 156.001H189.69L191.191 150.85H196.329L198.26 156.001Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.321 101.667C229.321 121.356 213.401 150.203 193.764 150.203C174.126 150.203 158.206 121.341 158.206 101.667C158.206 92.2123 161.952 83.1446 168.62 76.4589C175.289 69.7732 184.333 66.0172 193.764 66.0172C203.194 66.0172 212.238 69.7732 218.907 76.4589C225.575 83.1446 229.321 92.2123 229.321 101.667Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.329 151.062H191.191L188.192 149.344H199.328L196.329 151.062Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.908 73.9635C180.908 73.9635 165.913 82.1252 163.781 98.4414L180.908 73.9635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.944 210.058L107.608 214.988L110.63 275.58L208.966 270.65L205.944 210.058Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.812 211.059L108.935 215.928L111.818 272.402L206.695 267.533L203.812 211.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.704 228.986L125.775 228.366L125.318 219.409L113.246 220.028L113.704 228.986Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.494 245.907L170.846 243.528L170.698 240.624L124.345 243.003L124.494 245.907Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.364 251.556L171.165 249.822L171.066 247.884L137.265 249.619L137.364 251.556Z",
    fill: "#037DBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 169.98,
    y1: 193.695,
    x2: 163.246,
    y2: 171.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1920.64,
    y1: 13396.8,
    x2: 2392.78,
    y2: 10978.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -13476.3,
    y1: 12026.5,
    x2: -11219.8,
    y2: 11050.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2532.54,
    y1: 6783.74,
    x2: 2099,
    y2: 5333.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1208.12,
    y1: 2025.33,
    x2: 1680.26,
    y2: -392.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -14118.4,
    y1: 4516.22,
    x2: -11861.9,
    y2: 3539.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: -8693.06,
    y1: 13620.2,
    x2: -9126.67,
    y2: 12169.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: -6105.31,
    y1: 11526.5,
    x2: -5633.18,
    y2: 9108.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -25489.4,
    y1: 12068.9,
    x2: -23232.9,
    y2: 11092.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: -7549.41,
    y1: 9029.45,
    x2: -7982.95,
    y2: 7578.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: -5300.65,
    y1: 4586.39,
    x2: -4831.36,
    y2: 2172.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -24034.3,
    y1: 7289,
    x2: -21777.8,
    y2: 6312.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 16258.3,
    y1: 40732.1,
    x2: 20063,
    y2: 40732.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 6195.62,
    y1: 54074.7,
    x2: 6544.68,
    y2: 54074.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 7234.02,
    y1: 38436.8,
    x2: 7559.33,
    y2: 38436.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 96684,
    y1: 68164.3,
    x2: 96684,
    y2: 18723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 483.679,
    y1: 47874.9,
    x2: -20.0782,
    y2: 37825.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 275,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmRegistration);
export default __webpack_public_path__ + "static/media/confirmRegistration.321e8a54.svg";
export { ForwardRef as ReactComponent };